import { createFileRoute } from "@tanstack/react-router";
import { ResponsiveBabylon } from "@/pages/3d/ux/ResponsiveBabylon";

export const Route = createFileRoute("/demo/3d/ux/basics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ResponsiveBabylon />;
}
